/**
 * Feature Media Slider.
 */
 class FeaturedMediaSlider extends DrupalBehavior {

  onReady(document) {
    $('.featured-media-slider').each(function () {
      if ($(this).find('.featured-media-slider__wrapper').children().find('.featured-media-cta').length > 1) {
        $(this).find('.featured-media-slider__wrapper').children().slick({
          arrows: true,
          dots: false,
          appendArrows: $(this).find('.featured-media-slider__buttons'),
          adaptiveHeight: true
        });

        // Prevent open video when slider it's swiped.
        $(this).find('.featured-media-slider__wrapper').children().on('beforeChange', (event, slick, currentSlide, nextSlide) => {
          $(this).find('.featured-media-slider__wrapper').children().addClass('block-video-open');
        });

        $(this).find('.featured-media-slider__wrapper').children().on('afterChange', (event, slick, currentSlide) => {
          $(this).find('.featured-media-slider__wrapper').children().removeClass('block-video-open');
        });

      } else {
        $(this).addClass('featured-media-slider--single');
      }
    });
  }

}

DrupalBehavior.register('camc', 'featuredmediaslider', FeaturedMediaSlider);
